"use strict";

exports.__esModule = true;
exports["default"] = CircleRight;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.004.063C7.2.063.063 7.201.063 15.996c0 8.807 7.137 15.942 15.941 15.942 8.801 0 15.934-7.135 15.934-15.942 0-8.795-7.133-15.933-15.934-15.933zm10.05 16.711a2.164 2.164 0 0 1-.398.616l-9.091 9.082a1.97 1.97 0 0 1-1.421.598 1.973 1.973 0 0 1-1.432-.607c-.353-.349-.56-.863-.56-1.403 0-.542.207-1.061.567-1.425l5.634-5.632H7.8a2.015 2.015 0 0 1-2.014-2.012c0-1.107.903-2.01 2.014-2.01h11.551l-5.628-5.623c-.769-.774-.769-2.074 0-2.842.38-.378.885-.585 1.421-.585s1.043.207 1.421.585l9.063 9.055c.204.217.342.435.436.668.098.222.151.485.151.751-.001.27-.054.533-.161.784z"
  }));
}